import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Button, Col, Modal, Row} from "react-bootstrap";

import {resetEntity, showMessage} from '../actions';
import {loadGeneralEnum} from "../actions/enums";
import {deleteTransaction, loadTransaction, saveTransaction} from '../actions/transactions';
import {defaultState} from '../reducers/entity';
import TransactionForm from '../components/transaction/TransactionForm';
import {Acl, breadcrumbs, Grid} from "./../utils";

class TransactionEditPage extends Component {

	constructor(props) {
		super(props);

		this.handleFetchEnums = this.handleFetchEnums.bind(this);
		this.handleSaveTransaction = this.handleSaveTransaction.bind(this);
		this.handleDeleteTransaction = this.handleDeleteTransaction.bind(this);
		this.handleOpenDeleteClick = this.handleOpenDeleteClick.bind(this);
		this.handleDismissDeleteClick = this.handleDismissDeleteClick.bind(this);

		this.state = {
			isDeleteModalOpen: false,
			deleteTransaction: null
		}
	}

	componentDidMount() {
		const transactionId = (this.props.match.params.transactionId || 'new')
		this.props.loadTransaction(transactionId, 'new' !== transactionId)
	}

	componentDidUpdate(prevProps) {
		const transactionId = (this.props.match.params.transactionId || 'new')
		if ((prevProps.match.params.transactionId || 'new') !== transactionId) {
			this.props.loadTransaction(transactionId, 'new' !== transactionId)
		}
	}

	componentWillUnmount() {
		this.props.resetEntity()
	}

	handleFetchEnums(enums) {
		for (const i in enums) {
			if (enums.hasOwnProperty(i)) {
				this.props.loadGeneralEnum(enums[i], {})
			}
		}
	}

	handleSaveTransaction(transaction) {
		return this.props.saveTransaction(transaction).then((json) => {
			if (json && json.response && json.response.result === 'OK') {
				const transactionId = json.response.data;
				// this.props.loadTransaction(transactionId, true);
				return new Promise((resolve, reject) => resolve(this.props.history.push('/transactions/' + transactionId)))
			} else {
				return new Promise((resolve, reject) => resolve())
			}
		})
	}

	handleOpenDeleteClick(transaction) {
		this.setState({isDeleteModalOpen: true, deleteTransaction: transaction})
	}

	handleDismissDeleteClick(e) {
		if (e) {
			e.preventDefault()
		}
		this.setState({isDeleteModalOpen: false, deleteTransaction: null})
	}

	handleDeleteTransaction(transaction) {
		return this.props.deleteTransaction(transaction.transactionId).then((json) => {
			this.handleDismissDeleteClick();
			if (json && json.response && json.response.result === 'OK') {
				return new Promise((resolve, reject) => resolve(this.props.history.push('/transactions')))
			}
		})
	}

	renderDeleteModal() {
		const {isDeleteModalOpen, deleteTransaction} = this.state;

		if (!isDeleteModalOpen) {
			return null
		}

		return (
			<Modal onHide={this.handleDismissClick} show={true}>
				<Modal.Header>
					<Modal.Title>Trvalé smazání faktury</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<p>Skutečně trvale odstranit fakturu <strong>{deleteTransaction.transactionId}</strong>? Takto akce je nevratná.</p>
				</Modal.Body>

				<Modal.Footer>
					<Row>
						<Col sm={12}>
							<Button variant={"link"} onClick={this.handleDismissDeleteClick}>Storno</Button>
							<Button type="submit" onClick={() => this.handleDeleteTransaction(deleteTransaction)} variant="danger">
								<span className="fa fa-trash"/> Trvale smazat fakturu</Button>
						</Col>
					</Row>
				</Modal.Footer>

			</Modal>
		)
	}

	render() {
		const {match: {params}, entity, session, enums} = this.props;

		if (entity.isFetchingItem || entity.item === null) {
			return Grid.renderIsFetchingData()
		}

		if ((!entity.transactionId && !Acl.isAllowed(session, Acl.right.TRANSACTION_NEW))
			|| (entity.transactionId && !Acl.hasAction(entity.item, Acl.transaction.EDIT))) {
			return Grid.renderIsDenied()
		}

		const initialValues = entity.item;
		const bc = [
			{url: '/transactions', title: 'Faktury'}
		];
		if (params.transactionId) {
			bc.push({url: '/transactions/' + params.transactionId, title: initialValues.transactionId ? initialValues.transactionId : '...'});
		} else {
			bc.push({url: '/transactions/new', title: 'Nová'});
		}

		return (
			<div>
				<Row>
					<Col xs={12}>
						{breadcrumbs(bc)}
					</Col>
				</Row>
				<TransactionForm {...entity} initialValues={initialValues}
					onSaveTransaction={this.handleSaveTransaction}
					onDeleteTransaction={this.handleOpenDeleteClick}
					onFetchEnums={this.handleFetchEnums} enums={enums} session={session}/>
				{this.renderDeleteModal()}
			</div>
		)
	}
}

TransactionEditPage.propTypes = {
	entity: PropTypes.object.isRequired,
	loadTransaction: PropTypes.func.isRequired,
	saveTransaction: PropTypes.func.isRequired,
	deleteTransaction: PropTypes.func.isRequired,
	loadGeneralEnum: PropTypes.func.isRequired,
	enums: PropTypes.object,
	session: PropTypes.object.isRequired,
};


const mapStateToProps = (state, ownProps) => {
	const {
		entities: {transactions},
		enums,
		session
	} = state;

	const entity = ownProps.match.params.transactionId
		? (transactions[ownProps.match.params.transactionId] || defaultState)
		: (transactions['new'] || Object.assign(defaultState, {item: {}}))

	return {
		entity,
		enums,
		session
	}
};

export default connect(mapStateToProps, {
	loadTransaction,
	saveTransaction,
	deleteTransaction,
	loadGeneralEnum,
	showMessage,
	resetEntity
})(TransactionEditPage)
